import { ButtonCheckbox, SaveableCard } from "@jasper/forms";
import { Group, Select, SimpleGrid, Stack, Text } from "@mantine/core";
import { withForm } from "../../../hooks/preferenceForm";
import { usePreferenceCardSave } from "../../../hooks/usePreferenceCardSave";
import { getFixedPreferenceDefaults } from "../fixedPreferenceForm";

const INLAY_CORE_MATERIALS = ["Métal NP", "Métal précieux"];
const SCAN_POST_TYPES = ["Pivomatic"];
const KEYED_INLAY_CORE = ["Non", "Oui"];
const CROWN_WITH_INLAY_CORE = ["Oui, par défaut", "Non"];

export const InlayCorePreferences = withForm({
  defaultValues: getFixedPreferenceDefaults(),
  render: function Render({ form }) {
    const { status, save } = usePreferenceCardSave(form, [
      "inlayCoreMaterial",
      "scanPostType",
      "keyedInlayCore",
      "crownWithInlayCore",
    ]);

    return (
      <SaveableCard
        title="Inlay-core"
        description="Reconstitution corono-radiculaire"
        status={status}
        onSave={save}
      >
        <Stack gap="s3">
          <SimpleGrid cols={2}>
            <Stack gap="s2">
              <Text variant="strong">Matériau de l&lsquo;inlay-core</Text>
              <form.Field name="inlayCoreMaterial">
                {field => (
                  <Select
                    data={INLAY_CORE_MATERIALS}
                    value={field.state.value}
                    onChange={field.handleChange}
                  />
                )}
              </form.Field>
            </Stack>
            <Stack gap="s2">
              <Text variant="strong">Type de scan post</Text>
              <form.Field name="scanPostType">
                {field => (
                  <Select
                    data={SCAN_POST_TYPES}
                    value={field.state.value}
                    onChange={field.handleChange}
                  />
                )}
              </form.Field>
            </Stack>
          </SimpleGrid>
          <>
            <Text variant="strong">Inlay-core claveté</Text>
            <form.Field name="keyedInlayCore">
              {field => (
                <Group>
                  {KEYED_INLAY_CORE.map(option => (
                    <ButtonCheckbox
                      key={option}
                      id={option}
                      isActive={field.state.value === option}
                      onClick={() => field.handleChange(option)}
                    >
                      {option}
                    </ButtonCheckbox>
                  ))}
                </Group>
              )}
            </form.Field>
          </>
          <>
            <Text variant="strong">
              Couronne réalisée avec l&lsquo;inlay-core
            </Text>
            <form.Field name="crownWithInlayCore">
              {field => (
                <Group>
                  {CROWN_WITH_INLAY_CORE.map(option => (
                    <ButtonCheckbox
                      key={option}
                      id={option}
                      isActive={field.state.value === option}
                      onClick={() => field.handleChange(option)}
                    >
                      {option}
                    </ButtonCheckbox>
                  ))}
                </Group>
              )}
            </form.Field>
          </>
        </Stack>
      </SaveableCard>
    );
  },
});
